let yuan = value => {
  return isNaN(value) ? 0.00 : (value / 100).toFixed(2)
}

let kong = value => {
  return !value ? '暂无' : value
}

export {yuan, kong}



// WEBPACK FOOTER //
// ./src/filters/filters.js